import { render } from "./ReviewersDepartmentDialog.vue?vue&type=template&id=c0e7f82a"
import script from "./ReviewersDepartmentDialog.vue?vue&type=script&lang=js"
export * from "./ReviewersDepartmentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__